import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'change-password',
        (state.get('change-password') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, action) {
    return state.set(
        'change-password',
        (state.get('change-password') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );
}

export function finish(state) {
    return state
        .set(
            'change-password',
            (state.get('change-password') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}

export function clear(state) {
    return state.set('change-password', Map());
}
